import * as React from "react";
import { ToastRegion, type ToastMessage } from "@mandrac/ui";

const ToastContext = React.createContext<(text: string, tone?: "ok" | "error") => void>(() => {});

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toasts, setToasts] = React.useState<ToastMessage[]>([]);
  const push = React.useCallback((text: string, tone: "ok" | "error" = "ok") => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t.slice(-2), { id, text, tone }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 4000);
  }, []);
  return (
    <ToastContext.Provider value={push}>
      {children}
      <ToastRegion toasts={toasts} />
    </ToastContext.Provider>
  );
}

export const useToast = () => React.useContext(ToastContext);
